import React, { useState } from "react";
import Homepage_Data from "../../../utils/HomepageData";
import right_arrow from "../../../assets/images/right_arrow.svg";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCountryFrom, setCountryTo } from "../../../store/slices/formSlice";
import { pushToDataLayer } from "../../../utils/gtm";

export default function Countries() {
  const { countries_list, send_money_to_countries, countries_data } =
    Homepage_Data;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const selectedCountry = countries_list[selectedIndex];

  const handleChange = (e) => setSelectedIndex(e.target.selectedIndex);

  return (
    <div className="mx-[20px] my-[50px] lg:mx-auto lg:max-w-7xl lg:px-8 lg:my-[100px]">
      <h2 className="text-[24px] font-[700] text-[#2C2C2C] lg:text-[40px] lg:text-center">
        {countries_data.heading}
      </h2>

      <p className="text-[14px] font-[600] text-[#888888] my-[15px] lg:text-[20px] lg:text-center lg:max-w-[1000px] lg:mx-auto lg:my-[25px]">
        {countries_data.desc}
      </p>

      <div className="flex bg-[#f4effb] h-[46px] rounded-lg px-[5px] mt-[20px] lg:max-w-[400px] lg:mx-auto lg:mt-[40px] items-center">
        <img
          className="w-[24px] h-[24px] object-contain mr-2"
          src={selectedCountry.img}
          alt={selectedCountry.name}
        />
        <select
          className="bg-[#f4effb] w-full text-[#7B3BCC] px-[10px] rounded-lg text-[14px] lg:text-[18px] font-[600] outline-none ring-0 border-transparent focus:border-transparent focus:ring-0"
          onChange={handleChange}
          value={selectedCountry.name}
        >
          {countries_list.map((item, i) => (
            <option key={i} value={item.name} className="font-[600]">
              {item.name}
            </option>
          ))}
        </select>
      </div>

      <div className="mt-[25px] lg:flex lg:justify-between lg:gap-[40px]">
        <SendMoneySection
          title="Send money to"
          countryName={selectedCountry.name}
          data={send_money_to_countries}
          direction="to"
        />
        <SendMoneySection
          title="Send money from"
          countryName={selectedCountry.name}
          data={send_money_to_countries}
          direction="from"
        />
      </div>
    </div>
  );
}

/** Reusable Send Money Section */
export const SendMoneySection = ({ title, countryName, data, direction }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClick = (item) => {
    const allCountries = [
      ...Homepage_Data.countries_list,
      ...Homepage_Data.send_money_to_countries,
    ];

    const fromCountry = allCountries.find(
      (c) => c.name === (direction === "to" ? item.name : countryName)
    );
    const toCountry = allCountries.find(
      (c) => c.name === (direction === "to" ? countryName : item.name)
    );

    if (fromCountry && toCountry) {
      dispatch(setCountryFrom(fromCountry));
      dispatch(setCountryTo(toCountry));
      navigate("/");
      pushToDataLayer("countries_viewed", {
        country_pair: fromCountry + "-" + toCountry,
      });
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="lg:w-[48%] mt-[25px] lg:mt-[0]">
      <div className="flex items-center">
        <h2 className="text-[#7B3BCC] lg:text-[20px]">
          {title} <span className="font-[600]">{countryName}</span>
        </h2>
        <img className="pl-[10px]" src={right_arrow} alt="Right Arrow" />
      </div>
      <div className="mt-[25px] px-[5px]">
        {data.map((item, index) => (
          <div
            key={index}
            className="flex mb-[15px] items-center gap-[10px] lg:mb-[20px]"
          >
            <a
              href="#"
              className="flex gap-[15px]"
              onClick={(e) => {
                e.preventDefault();
                handleClick(item);
              }}
            >
              <img className="w-[24px]" src={item.img} alt={item.name} />
              <h2 className="text-[13px] text-[#2C2C2C] lg:text-[18px]">
                Send money {direction}{" "}
                <span className="font-[600]">{countryName}</span>{" "}
                {direction === "to" ? "from" : "to"}{" "}
                <span className="font-[600]">{item.name}</span>
              </h2>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};
